<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Switch to District Wide</p>
        <span
          class="icon is-right"
          @click="closeModal">
          <font-awesome-icon :icon="['fal', 'times']" />
        </span>
      </header>
      <section class="modal-card-body">
        <div class="modal-body">
          If you have made changes in Elections to the cluster or school participation settings,
           these changes will be deleted if you switch to District Wide.
           Are you sure you want to switch to District Wide?
        </div>
        <div class="update-box">
          <a @click="closeModal">Cancel</a>
          <button
            class="button is-primary"
            @click="confirm">
              Switch to District Wide
          </button>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faTimes,
} from '@fortawesome/pro-light-svg-icons';

library.add(
  faTimes,
);

export default {
  methods: {
    async confirm() {
      this.$emit('confirm');
    },
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>

<style lang="sass" scoped>
  .modal-card-head
    background-color: #F5F5F5
    text-align: left
  .modal-card-title
    margin-bottom: 0 !important
  .modal-card-body
    border-bottom-right-radius: .4rem
    border-bottom-left-radius: .4rem
    text-align: left
  .modal-body
    margin-bottom: 1rem
    display: flex
    justify-content: flex-start
  .update-box
    display: flex
    align-items: center
    justify-content: flex-end
    button
      margin-left: 1rem
</style>
